import React from 'react';
import { Form } from 'react-bootstrap';

export function ReportFormField({ field, formData, onChange }) {
  let form_control = null;
  const label = field.required ? field.label + '*' : field.label;

  if (field.type === 'DateField') {
    form_control = (
      <Form.Control
        type="date"
        name={field.name}
        onChange={onChange}
        value={formData[field.name] || ''}
        aria-describedby={field.name + '_help'}
      />
    );
  } else if (field.type === 'BooleanField') {
    return (
      <Form.Check
        key={field.name}
        id={field.name}
        type="checkbox"
        name={field.name}
        label={label}
        onChange={onChange}
        checked={!!formData[field.name]}
        aria-describedby={field.name + '_help'}
      />
    );
  } else if (field.type === 'FileField') {
    form_control = (
      <Form.Control
        type="file"
        name={field.name}
        onChange={onChange}
        aria-describedby={field.name + '_help'}
      />
    );
  } else if (field.type === 'CharField') {
    form_control = (
      <Form.Control
        type="text"
        name={field.name}
        onChange={onChange}
        value={formData[field.name] || ''}
        id={field.name}
        aria-describedby={field.name + '_help'}
      />
    );
  } else if (field.type === 'MultipleChoiceField') {
    form_control = (
      <Form.Select
        multiple
        name={field.name}
        onChange={onChange}
        value={formData[field.name] || []}
        htmlSize={20}
      >
        {field.choices.map((choice) => {
          let choice_id = choice;
          let choice_label = choice;
          if (Array.isArray(choice) && choice.length > 1) {
            choice_id = choice[0];
            choice_label = choice[1];
          }
          return (
            <option key={choice_id} value={choice_id}>
              {choice_label}
            </option>
          );
        })}
      </Form.Select>
    );
  }

  return (
    <Form.Group key={field.name} className="mb-3">
      <Form.Label>{label}</Form.Label>
      {form_control}
      {field.help_text && (
        <Form.Text id={field.name + '_help'} muted>
          {field.help_text}
        </Form.Text>
      )}
    </Form.Group>
  );
}
